export default __webpack_public_path__ + "maps-examples-clustering-with-images-thumbnail-480-ce950750295c34861e526e72f23bc343.png";